// NOTE: NSAI-5804 — shapes for the client-side mirror of the server's resource
// path canonicalizer. Kept beside the util rather than in the shared `types/`
// folder because nothing outside it consumes them.

export enum ESkillResourceFolderRejection {
  // NOTE: Anything structurally impossible as a bundle path — a traversal
  // segment, an absolute or drive-qualified path, a backslash, an empty or
  // padded segment, a control character.
  INVALID = "invalid",
  TOO_DEEP = "too_deep",
  TOO_LONG = "too_long",
}

export interface IValidateSkillResourceFolderProps {
  folder: string;
  // NOTE: The name the folder will hold. The depth and byte caps apply to the
  // FULL path the server will store, so the folder cannot be judged alone — a
  // folder that fits on its own can still push a long file name past the cap.
  fileName: string;
}

export interface IValidSkillResourceFolder {
  isValid: true;
  // NOTE: The full `folder/fileName`, NFC-normalized — the exact string the
  // upload should carry, so a caller never re-joins it and never has to know
  // that the root case has no separator.
  skillRelativePath: string;
}

export interface IInvalidSkillResourceFolder {
  isValid: false;
  reason: ESkillResourceFolderRejection;
}

// NOTE: A discriminated union for the same reason the server's is one: a caller
// must not be able to read the path without having proved it was accepted.
export type TValidateSkillResourceFolderResult =
  | IValidSkillResourceFolder
  | IInvalidSkillResourceFolder;

export interface IFindShadowedResourcePathProps {
  // NOTE: Paths already on the version — kept resources plus uploads in flight.
  existingPaths: readonly string[];
  skillRelativePath: string;
}
